module.exports = __webpack_public_path__ + "img/02.0976169e.png";